import LegalLayout from "@/components/LegalLayout";
import { Link } from "react-router-dom";
import { openCookieSettings } from "@/components/CookieConsent";

export default function CookieHinweis() {
  return (
    <LegalLayout title="Cookie-Hinweis">
      <p>
        Um den Besuch unserer Website attraktiv zu gestalten und die Nutzung bestimmter Funktionen zu ermöglichen,
        verwenden wir Cookies, also kleine Textdateien, die auf Ihrem Endgerät abgelegt werden. Teilweise werden
        diese Cookies nach Schließen des Browsers automatisch wieder gelöscht (sog. „Session-Cookies"), teilweise
        verbleiben diese Cookies länger auf Ihrem Endgerät und ermöglichen das Speichern von Seiteneinstellungen
        (sog. „persistente Cookies").
      </p>

      <h2>Welche Cookies setzen wir?</h2>
      <ul>
        <li>
          <strong>Technisch notwendige Cookies</strong> – z.B. zum Speichern Ihres Tracking-Codes, Ihrer
          Chatbot-Session und Ihrer Zustimmung zu diesem Cookie-Hinweis. Diese Cookies sind für den Betrieb
          der Website erforderlich.
        </li>
        <li>
          <strong>Funktions-Cookies</strong> – speichern z.B. Ihre Eingaben im Schadensmeldungs-Assistenten,
          damit Sie den Vorgang nicht von vorne beginnen müssen.
        </li>
      </ul>

      <h2>Rechtsgrundlage</h2>
      <p>
        Sofern durch einzelne von uns eingesetzte Cookies auch personenbezogene Daten verarbeitet werden, erfolgt
        die Verarbeitung gemäß Art. 6 Abs. 1 lit. b DSGVO entweder zur Durchführung des Vertrages, gemäß
        Art. 6 Abs. 1 lit. a DSGVO im Falle einer erteilten Einwilligung oder gemäß Art. 6 Abs. 1 lit. f DSGVO
        zur Wahrung unserer berechtigten Interessen an der bestmöglichen Funktionalität der Website sowie einer
        kundenfreundlichen und effektiven Ausgestaltung des Seitenbesuchs.
      </p>

      <h2>Cookies in Ihrem Browser verwalten</h2>
      <p>
        Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und einzeln
        über deren Annahme entscheiden oder die Annahme von Cookies für bestimmte Fälle oder generell ausschließen
        können. Bitte beachten Sie, dass bei Nichtannahme von Cookies die Funktionalität unserer Website
        eingeschränkt sein kann.
      </p>

      <h2>Cookie-Einstellungen ändern</h2>
      <p>
        Sie können Ihre Einwilligung jederzeit widerrufen oder anpassen. Klicken Sie dazu auf den folgenden Button,
        um den Cookie-Banner erneut zu öffnen:
      </p>
      <p>
        <button
          data-testid="reopen-cookie-banner-btn"
          onClick={openCookieSettings}
          className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors no-underline"
        >
          Cookie-Einstellungen öffnen
        </button>
      </p>

      <h2>Weitere Informationen</h2>
      <p>
        Ausführliche Informationen zur Datenverarbeitung – insbesondere zu Cookie-Consent-Tools, Drittanbieter-Cookies
        und Ihren Rechten als Betroffene*r – finden Sie in unserer{" "}
        <Link to="/datenschutz">Datenschutzerklärung</Link>.
      </p>
    </LegalLayout>
  );
}
